import * as React from 'react';
import { Component } from 'react';
import { AppUser } from 'Src/views/App/App';
import { School } from '../../../../../models/school';
import { Field, Form, Formik } from 'formik';
import { getPostcodes } from '../../../../../helpers/venue/venue';
import { getName, getPostcode, searchFunctionSchoolNinSchools } from '../../../../../helpers/autocomplete/autocomplete';
import { Autocomplete } from '../../../../../components/Autocomplete/Autocomplete';

interface Props {
  user: AppUser;
  postcode?: string;
  schools: School[];
  onCancel: () => void;
  onSubmit: (data: any) => void;
}

interface State { postcode: string; }

export class SchoolFormModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { postcode: undefined };
  }

  getSchools = (text: string) => searchFunctionSchoolNinSchools(text, this.props.schools, this.state.postcode);

  render() {
    const { user } = this.props;
    return (
      <div className="unionAddSchoolForm">
        <Formik
          onSubmit={values => this.props.onSubmit({ schoolId: values.schoolId })}
          initialValues={{ postcode: undefined, school: undefined, schoolId: '' }}
        >
          {({ setFieldValue, values }) => (
            <Form className="unionAddSchoolForm__form">
              <div className="unionAddSchoolForm__intro">
                Search by postcode to narrow the results, then choose the school you want to add to this union.
              </div>
              <div className="unionAddSchoolForm__field">
                <label>Postcode <span>Optional</span></label>
                <div className="unionAddSchoolForm__inputWithAction">
                  <Autocomplete
                    searchFunction={text => getPostcodes(text, user)}
                    getElementTitle={getPostcode}
                    customClass="mFullWidth unionAddSchoolForm__autocomplete"
                    defaultItem={values.postcode}
                    onSelect={postcode => {
                      this.setState({ postcode });
                      setFieldValue('postcode', postcode);
                    }}
                    placeholder="Start typing a postcode…"
                    isMenuPortal={true}
                    menuMaxHeight={220}
                  />
                  <button
                    type="button"
                    className="unionAddSchoolForm__clear"
                    onClick={() => {
                      setFieldValue('postcode', undefined);
                      this.setState({ postcode: undefined });
                    }}
                  >
                    Clear
                  </button>
                </div>
              </div>
              <div className="unionAddSchoolForm__field">
                <label>School <em>*</em></label>
                <Field name="schoolId">
                  {() => (
                    <Autocomplete
                      searchFunction={this.getSchools}
                      getElementTitle={getName}
                      customClass="mFullWidth unionAddSchoolForm__autocomplete"
                      defaultItem={values.school}
                      onSelect={school => {
                        setFieldValue('school', school);
                        setFieldValue('schoolId', school.id);
                      }}
                      placeholder="Search by school name…"
                      isItemWithImage={true}
                      fallbackImage="/dist/images/logoImage.png"
                      isMenuPortal={true}
                      menuMaxHeight={280}
                    />
                  )}
                </Field>
              </div>
              <div className="unionAddSchoolForm__actions">
                <button type="button" className="unionAddSchoolForm__cancel" onClick={this.props.onCancel}>Cancel</button>
                <button disabled={!values.school} type="submit" className="unionAddSchoolForm__submit">Add school</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
